export const PERMISSIONS={
    view_products:{
        slug:"view_products",
        permissionType:"Product"
    },
    create_products:{
        slug:"create_products",
        permissionType:"Product"
    },
    update_products:{
        slug:"update_products",
        permissionType:"Product"
    },
    download_product_images:{
        slug:"download_product_images",
        permissionType:"Product"
    },
    delete_products:{
        slug:"delete_products",
        permissionType:"Product"
    },
    create_catalogues:{
        slug:"create_edit_catalogues",
        permissionType:"Catalogue"
    },
    update_catalogues:{
        slug:"create_edit_catalogues",
        permissionType:"Catalogue"
    },
    update_catalogues_link_security:{
        slug:"update_catalogues_link_security",
        permissionType:"Catalogue"
    },
    delete_catalogues:{
        slug:"delete_catalogues",
        permissionType:"Catalogue"
    },
    view_catalogues:{
        slug:"view_catalogue_history",
        permissionType:"Catalogue"
    },
    global_permissions:{
        slug:"global_permissions",
        permissionType:"Global"
    },
    download_ppt_excel:{
        slug:"access_ppt_excel_link",
        permissionType:"Catalogue"
    }

}